module.exports = __webpack_public_path__ + "img/acc.d2540b5b.svg";